import Grid from '@mui/material/GridLegacy';
import TextField from '@mui/material/TextField';
import type { ChangeEvent } from 'react';

export type FieldType = 'username' | 'password';

interface CredentialFieldProps {
    fieldType: FieldType;
    value: string;
    label: string;
    onChange: (fieldType: FieldType, next: string) => void;
    rowClassName: string;
    inputClassName: string;
}

export const CredentialField = ({
    fieldType,
    value,
    label,
    onChange,
    rowClassName,
    inputClassName,
}: CredentialFieldProps) => {
    const handle = (event: ChangeEvent<HTMLInputElement>) =>
        onChange(fieldType, event.target.value);
    return (
        <Grid className={rowClassName}>
            <TextField
                className={inputClassName}
                onChange={handle}
                label={label}
                variant="outlined"
                value={value}
                type={fieldType === 'password' ? 'password' : undefined}
                autoComplete="off"
            />
        </Grid>
    );
};
